<template>
  <div>
    <MyApps />
  </div>
</template>

<script setup>
import MyApps from '@/components/organisms/MyApps/MyApps.vue'
</script>
